import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {updateNewCommercialUser} from '../actions/create';

import {updateCommercialUser} from '../actions/edit';

const EditableCell = ({
  row,
  'value': initialValue,
  'column': {'id': columnId},
  uniqueValue,
  width = 'auto',
}) => {
  const [value, setValue] = React.useState(initialValue);
  const [isEditable, setIsEditable] = useState(false);

  const {modifiedRows, newRows, deletedRows, editableRowIndex} = useSelector((state) => state.commercialUsers);
  const dispatch = useDispatch();

  const onChange = (e) => {
    setValue(e.target.value);
  };

  const onBlur = () => {
    if (newRows[uniqueValue]) {
      return dispatch(updateNewCommercialUser(uniqueValue, {
        [columnId]: value,
      }));
    }

    dispatch(updateCommercialUser(uniqueValue, {
      [columnId]: value,
    }));
  };

  // If the initialValue is changed external, sync it up with our state
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  useEffect(() => {
    setIsEditable((editableRowIndex === row.index));
  }, [editableRowIndex]);

  let customStyles = {
    width,
  };

  if (newRows[uniqueValue]) {
    customStyles = {
      ...customStyles,
      'backgroundColor': '#a0fc7e',
    };
  } else
  if (deletedRows[uniqueValue]) {
    customStyles = {
      ...customStyles,
      'backgroundColor': '#ff5757',
    };
  } else
  if (modifiedRows[uniqueValue]?.[columnId]) {
    customStyles = {
      ...customStyles,
      'backgroundColor': 'yellow',
    };
  }

  return <input
    disabled={!isEditable}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    style={customStyles}
  />;
};

export default EditableCell;
